import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ContainerData = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: 10px;
  margin-left: 10px;
`;

export const ContainerInfo = styled.div`
  display: flex;
  margin-top: 10;
  flex-direction: row;
  margin-right: 10px;
  margin-left: 10px;
`;

export const ContainerInternoCheck = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: 10px;
  margin-left: 10px;
  align-items: center;
  justify-content: center;
`;
